export const INCLUDED_FILTERS = ['sale', 'isNew', 'styleGroup']

export const CUP_ATTRIBUTE_IDS_PREV: (number | string)[] = [
  215752, 215759, 215766, 215773, 228696, 215753, 215760, 215767, 215774,
  228700, 215754, 215761, 215768, 215775, 215786, 215787, 215788, 215797,
  215794, 215795, 215796, 215798, 215826, 217380, 217382, 217384, 216242,
  215799, 215800, 215801, 215802, 215790, 215780, 215781, 215782, 215783,
  228676, 215789, 215748, 215755, 215762, 215769, 228680, 215791, 215749,
  215756, 215763, 215770, 228684, 215792, 215750, 215757, 215764, 215771,
  228688, 215793, 215751, 215758, 215765, 215772, 228692, 237722, 237731,
  237735, 237744, 238589, 239140, 237721, 237730, 237738, 237745, 238590,
  237766, 237767, 237768, 237769, 237846, 237848, 237851, 237854, 237845,
  237849, 237852, 237855, 237847, 237850, 237853, 237856, 238175, 238727,
  238561, 238796, 238797, 238728, 238720, 237716, 237723, 237732, 237741,
  238584, 239124, 238722, 237717, 237727, 237733, 237739, 238585, 239127,
  238723, 237718, 237726, 237734, 237740, 238587, 239131, 238721, 237720,
  237729, 237736, 237742, 238586, 239135, 238724, 237719, 237728, 237737,
  237743, 238588, 239136,
]

export const CUP_ATTRIBUTE_IDS_PROD: (number | string)[] = [
  215851, 215864, 215872, 215880, 217605, 249353, 215856, 215865, 215873,
  215882, 217609, 215855, 215866, 215874, 215881, 249354, 215854, 215867,
  215875, 215883, 215910, 215911, 215912, 216002, 215999, 216000, 216001,
  216003, 215884, 215857, 216005, 216006, 216007, 215897, 215848, 215894,
  215895, 215896, 217585, 249349, 215898, 215849, 215861, 215868, 215876,
  217589, 249348, 215901, 215852, 215860, 215869, 215877, 217593, 249350,
  215899, 215850, 215862, 215870, 215878, 217598, 249351, 215900, 215853,
  215863, 215871, 215879, 217601, 249352, 239061, 239056, 239069, 239076,
  239156, 239903, 239062, 239079, 239070, 239077, 239158, 239063, 239081,
  239085, 239100, 239164, 239083, 239080, 239095, 239101, 239084, 239082,
  239096, 239126, 239116, 239097, 239117, 239329, 239348, 239086, 239112,
  239496, 239102, 239087, 239078, 239051, 239064, 239071, 239140, 239888,
  239088, 239057, 239052, 239065, 239072, 239146, 239892, 239090, 239058,
  239053, 239066, 239073, 239145, 239894, 239089, 239059, 239055, 239067,
  239074, 239149, 239898, 239091, 239060, 239054, 239068, 239075, 239153,
  239901,
]

export const BROKEN_FILTER_IDS_PREV: number[] = [237697, 213663, 212384, 212381]

export const BROKEN_FILTER_IDS_PROD: number[] = [
  229101, 216236, 216266, 216263, 213663, 212381,
]
